'use client'

import type { ReactNode } from 'react'

import './FeesAndCharges.css'
import '@/views/personal/financing/styles/CashlinePersonal.css'

import parse from 'html-react-parser'

import { LinkButton } from '@/components/buttons'
import { InfoItem } from '@/components/pf'

interface FeesAndChargesProps {
  title?: ReactNode
  image?: string | null
  note?: ReactNode
  documents?: { text?: string; title?: string; content?: string; backgroundColor?: string }[]
  buttons?: { title?: string; link?: string }[]
  className?: string
}

const FeesAndCharges = ({
  title = 'Apply easily',
  image,
  note,
  documents = [
    {
      text: 'Latest <b>EPF statement</b>',
      backgroundColor: '#DCE9FF'
    },
    {
      text: 'Latest <b>3 months salary slip</b> and personal bank statement reflecting salary crediting',
      backgroundColor: '#F2F4F7'
    }
  ],
  buttons = [
    {
      title: 'Product Disclosure Sheet',
      link: ''
    },
    {
      title: 'Download Application Form',
      link: ''
    }
  ],
  className = ''
}: FeesAndChargesProps) => {
  return (
    <section className="section about container" id="fees-and-charges">
      <div className="row align-items-center" data-aos="fade-up" data-aos-delay="200">
        <div className="col-md-4 order-1 order-lg-1 img-fluid-pf">
          <img
            src={image ?? 'https://www.alrajhibank.com.my/assets/files/pf_alia_8c3352640b.webp'}
            alt="Rates and charges"
            className="img-fluid-pf"
          />
        </div>

        {/* Content column */}
        <div
          className="col-md-8 order-2 order-lg-2"
          data-aos="zoom-in"
          data-aos-delay="200"
          style={{ marginTop: '30px' }}
        >
          <div className={className ? className : 'pf-rates pb-4'}>
            <h2>{title}</h2>
          </div>
          <div className={className ? `row ${className}` : 'row'}>
            {documents.map((item, index) => (
              <InfoItem key={index} header={item.title} subheader={item.content} />
            ))}
          </div>
          <div>{note && (typeof note === 'string' ? parse(note) : note)}</div>

          <div className="link-button-row pt-5">
            {buttons.map((item, index) => (
              <LinkButton key={index} text={item.title} pdf={item.link} />
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export default FeesAndCharges
